import RichText from 'Custom/RichText';
import AjustableImage from 'Custom/AjustableImage';
import Button from 'Nori/Button';

import EFFECTIVE_IMAGE from 'Images/misc/effective-carousel-blue.png';
import CALENDAR_IMAGE from 'Images/misc/calendar-blue.png';
import TAMPON_IMAGE from 'Images/misc/tampon-blue.png';
import CIRCLE_IMAGE from 'Images/misc/circle-arrows-blue.png';
import HAND_IMAGE from 'Images/misc/hand-blue.png';

export const CARDS_CAROUSEL = [
  {
    title: 'Non-daily',
    subtitle: 'Fact 1',
    navigationTitle: 'NON-DAILY',
    image: (
      <AjustableImage
        image={{
          src: CALENDAR_IMAGE,
          alt: '',
        }}
      />
    ),
    content: (
      <>
        <RichText>
          <p data-qa-tag="nexplanon-does-not" className="body-text">
            NEXPLANON does not require any daily, weekly, or monthly dosing and
            provides 5 years<sup>†</sup> of pregnancy prevention.
          </p>
          <p data-qa-tag="nexplanon-does-not-caption" className="caption">
            <sup>†</sup>NEXPLANON must be removed by the end of the fifth year.
          </p>
        </RichText>
        <Button
          data-qa-tag="nexplanon-does-not-button"
          href="/how-does-nexplanon-work/"
          data-design-type="clickAction"
          data-design-category="button_vd"
          data-design-action="Button"
          data-design-label="Show Me How It Works"
          data-design-nori_id="Carousel"
          data-design-module_name="GET TO KNOW NEXPLANON"
          data-design-module_no="01"
          data-design-element_no="01"
        >
          Show Me How It Works
        </Button>
      </>
    ),
  },
  {
    title: 'Highly effective',
    subtitle: 'Fact 2',
    navigationTitle: 'HIGHLY EFFECTIVE',
    image: (
      <AjustableImage
        image={{
          src: EFFECTIVE_IMAGE,
          alt: 'Over 99% Effective: Less Than 1 Pregnancy per 100 Women Who Used NEXPLANON® (etonogestrel implant) 68 mg Radiopaque for 1 Year',
        }}
      />
    ),
    content: (
      <>
        <RichText>
          <p data-qa-tag="nexplanon-highly-effective" className="body-text">
            It is just as effective as the pill, without the daily hassle.
          </p>
          {/* <p className="caption">
            *Less than 1 pregnancy per 100 women who used NEXPLANON for 1 year.
          </p> */}
        </RichText>
        <Button
          data-qa-tag="nexplanon-highly-effective-button"
          href="/effectiveness/"
          data-design-type="clickAction"
          data-design-category="button_vd"
          data-design-action="Button"
          data-design-label="Learn More About Effectiveness"
          data-design-nori_id="Carousel"
          data-design-module_name="GET TO KNOW NEXPLANON"
          data-design-module_no="01"
          data-design-element_no="02"
        >
          Learn More About Effectiveness
        </Button>
      </>
    ),
  },
  {
    title: 'Small and flexible',
    subtitle: 'Fact 3',
    navigationTitle: 'SMALL & FLEXIBLE',
    image: (
      <AjustableImage
        image={{
          src: HAND_IMAGE,
          alt: "Visual of the Size of an Implant Relative to a Person's Hand",
        }}
      />
    ),
    content: (
      <>
        <RichText>
          <p data-qa-tag="nexplanon-small-flexible" className="body-text">
            NEXPLANON can be inserted in a few minutes<sup>#</sup> at a
            healthcare professional's office. It’s placed just under the skin of
            your inner, non-dominant upper arm.
          </p>
          <p data-qa-tag="nexplanon-releases-hormone">
            It releases a continuous low dose of hormone to prevent pregnancy.
          </p>
          <p data-qa-tag="in-a-clinical-trial" className="caption">
            <sup>#</sup>In a clinical trial, the mean insertion time (from the
            removal of the protection cap of the applicator until retraction of
            the needle from the arm) was 27.9 ± 29.3 seconds.
          </p>
        </RichText>
        <Button
          data-qa-tag="nexplanon-small-flexible-button"
          href="/insertion/"
          data-design-type="clickAction"
          data-design-category="button_vd"
          data-design-action="Button"
          data-design-label="Show Me How It Works"
          data-design-nori_id="Carousel"
          data-design-module_name="GET TO KNOW NEXPLANON"
          data-design-module_no="01"
          data-design-element_no="03"
        >
          Show Me How It Works
        </Button>
      </>
    ),
  },
  {
    title: 'Periods may change',
    subtitle: 'Fact 4',
    navigationTitle: 'PERIODS MAY CHANGE',
    image: <AjustableImage image={{ src: TAMPON_IMAGE, alt: '' }} />,
    content: (
      <>
        <RichText>
          <p data-qa-tag="nexplanon-periods-may-change" className="body-text">
            You may experience longer or shorter bleeding during your periods or
            have no bleeding at all. The time between periods may vary, and in
            between periods, you may also have spotting.
          </p>
        </RichText>
        <Button
          data-qa-tag="nexplanon-periods-may-change-button"
          href="/period-changes/"
          data-design-type="clickAction"
          data-design-category="button_vd"
          data-design-action="Button"
          data-design-label="Learn More"
          data-design-nori_id="Carousel"
          data-design-module_name="GET TO KNOW NEXPLANON"
          data-design-module_no="01"
          data-design-element_no="04"
        >
          Learn More
        </Button>
      </>
    ),
  },
  {
    title: `It's reversible`,
    subtitle: 'Fact 5',
    navigationTitle: 'IT’S REVERSIBLE',
    image: <AjustableImage image={{ src: CIRCLE_IMAGE, alt: '' }} />,
    content: (
      <>
        <RichText>
          <p data-qa-tag="nexplanon-reversible" className="body-text">
            NEXPLANON is reversible. If your plans change, it can be removed by
            a trained healthcare professional at any time during the 5-year
            period.<sup>§</sup>
          </p>
          <p data-qa-tag="nexplanon-reversible-caption" className="caption">
            <sup>§</sup>NEXPLANON must be removed by the end of the fifth year.
          </p>
        </RichText>
        <Button
          data-qa-tag="nexplanon-reversible-button"
          href="/removal/"
          data-design-type="clickAction"
          data-design-category="button_vd"
          data-design-action="Button"
          data-design-label="Learn More About Removal"
          data-design-nori_id="Carousel"
          data-design-module_name="GET TO KNOW NEXPLANON"
          data-design-module_no="01"
          data-design-element_no="05"
        >
          Learn More About Removal
        </Button>
      </>
    ),
  },
];
